/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';

import { RetailTransactionView } from '.';

const RetailTransaction = ({
  locale, storeHeaderInfo, timezone, transaction, footers
}) => {
  const giftTransactions = [...(transaction.RetailTransaction ? transaction.RetailTransaction?.LineItems?.filter((item) => item?.Sale?.GiftReceiptFlag) : []),
    ...(transaction.OrderTransaction ? transaction.OrderTransaction?.LineItems?.filter((item) => item?.Sale?.GiftReceiptFlag) || [] : [])
  ];
  return (
    <section className="p2-sm body-4 flx-jc-sm-c display-print" style={{ margin: 'auto', maxWidth: 275, textAlign: 'center' }}>
      {!!giftTransactions.length && giftTransactions.map((giftTransaction, index) => <RetailTransactionView isGiftReceipt footers={footers} giftTransaction={giftTransaction?.Sale} index={index} locale={locale} storeHeaderInfo={storeHeaderInfo} timezone={timezone} transaction={transaction} />)}
      <RetailTransactionView footers={footers} locale={locale} storeHeaderInfo={storeHeaderInfo} timezone={timezone} transaction={transaction} />
    </section>
  );
};

RetailTransaction.defaultProps = {
  footers: [],
  locale: {},
  storeHeaderInfo: {},
  timezone: '',
  transaction: {}
};

RetailTransaction.propTypes = {
  footers: PropTypes.arrayOf(PropTypes.string),
  locale: PropTypes.shape(),
  storeHeaderInfo: PropTypes.shape(),
  timezone: PropTypes.string,
  transaction: PropTypes.shape()
};

export default RetailTransaction;
